<template>
  <div class="payments px-12">
    <NavBar :admin="true" :items="items" />
    <v-main>
			<v-container>
				<v-row no-gutters>
					<v-btn
            color="primary"
            text
            @click="showBankTransferInfo = true"
						small
          >
            Info Transferência Bancária
            <v-icon small class="ml-1">mdi-bank</v-icon>
          </v-btn>
					<v-dialog v-model="showBankTransferInfo" max-width="360px">
						<v-card v-if="bankTransferInfo">
							<v-card-title class="text-subtitle-2 primary--text mb-3 secondary">
								<v-icon small color="primary" class="mr-1">mdi-bank</v-icon>
								Info Transferência Bancária
							</v-card-title>
							<v-card-text>
								<v-form ref="bankTransferInfoForm">
									<v-row no-gutters>
										<v-col cols="12">
											<v-text-field
												v-model="bankTransferInfo.beneficiary"
												label="Beneficiário"
												outlined
												:rules="[required]"
											/>
										</v-col>
										<v-col cols="12">
											<v-text-field
												v-model="bankTransferInfo.iban"
												label="IBAN"
												outlined
												:rules="[required]"
											/>
										</v-col>
										<v-col cols="12">
											<v-text-field
												v-model="bankTransferInfo.bic"
												label="BIC"
												outlined
												:rules="[required]"
											/>
										</v-col>
									</v-row>
								</v-form>
							</v-card-text>
							<v-divider></v-divider>
							<v-card-actions>
								<v-btn small color="primary darken-1" text @click="showBankTransferInfo = false">
									<translate>Close</translate>
								</v-btn>
								<v-spacer></v-spacer>
								<v-btn small color="primary" outlined depressed text @click="saveBankTransferInfo">
									<translate>Save</translate>
								</v-btn>
							</v-card-actions>
						</v-card>
					</v-dialog>
				</v-row>
				<v-row no-gutters class="mt-3">
					<v-col>
						<v-menu
							v-model="dateMenu"
							:close-on-content-click="false"
							:nudge-right="40"
							transition="scale-transition"
							offset-y
							min-width="290px"
						>
							<template v-slot:activator="{ on }">
								<v-text-field
									dense
									solo
									v-model="dates"
									label="Intervalo da data de criação"
									append-icon="event"
									readonly
									v-on="on"
									class="px-2"
								></v-text-field>
							</template>
							<v-date-picker range color="primary" v-model="dates" @input="dates[1] ? dateMenu = false : null"></v-date-picker>
						</v-menu>
					</v-col>
					<v-col>
						<v-select
							dense
							solo
							item-text="name"
							item-value="id"
							:items="subscriptionPlans"
							v-model="selectedPlans"
							hide-details
							multiple
							return-object
							label="Planos"
						>
						</v-select>
					</v-col>
					<v-col>
						<v-select
							dense
							solo
							item-text="name"
							item-value="id"
							:items="status"
							v-model="selectedStatus"
							hide-details
							return-object
							label="Estado"
							class="px-2"
						>
						</v-select>
					</v-col>
					<v-col md="auto">
						<v-checkbox
							v-model="receipt"
							class="mt-1 text-caption--text"
							color="primary"
							label="Com recibo"
							hide-details
						/>
					</v-col>
				</v-row>
				<v-progress-linear v-if="loading" indeterminate top color="primary"></v-progress-linear>
				<template v-else>
					<p v-if="payments.length == 0" class="font-weight-thin ml-2" v-translate key="no-payments">No payments.</p>
					<v-list v-else class="mt-5">
						<PaymentItem v-for="(payment, index) in paymentsFiltered" :key="index" :payment="payment" :admin="true" :showSpace="true" />
					</v-list>
				</template>
			</v-container>
    </v-main>
  </div>
</template>

<script>
import NavBar from "@/components/authentication/NavBar.vue";
import PaymentItem from "@/components/payments/PaymentItem.vue";
import axios from "axios";

export default {
  name: "Payments",
  components: {
    NavBar,
    PaymentItem
  },
  data: () => ({
		loading: false,
		payments: [],
		dateMenu: false,
		dates: null,
		subscriptionPlans: [],
		selectedPlans: [],
		status: [],
		selectedStatus: [],
		receipt: false,
		bankTransferInfo: null,
		showBankTransferInfo: false
  }),
  computed: {
		required() {
			return value => !!value || this.$gettext("Required.");
    },
		items() {
			return [
				{
					text: this.$gettext("Dashboard"),
					disabled: false,
					link: true,
					to: "/admin/dashboard"
				},
				{
					text: this.$gettext("Payments"),
					disabled: true,
					link: true
				}
			];
		},
		paymentsFiltered() {
			let paymentsFiltered = this.payments;
			
			if(this.selectedPlans.length > 0) {
				paymentsFiltered = this.payments.filter(p => {
					if(p.subscription_plan) {
						let exist = false;
						this.selectedPlans.forEach(sp => {
							if(sp.id == p.subscription_plan.id) exist = true;
						});
						if(exist) return true;
					}
					return false;
				});
			}

			if(this.dates && this.dates.length == 2) {
				paymentsFiltered = paymentsFiltered.filter(p => {
					if(p.date) {
						let startDate = new Date(this.dates[0]);
						let finalDate = new Date(this.dates[1]);
						let createdDate = new Date(p.date);
						if(createdDate >= startDate && createdDate <= finalDate) return true;
						else return false;
					}
				});
			}

			if(this.selectedStatus.length > 0) {
				paymentsFiltered = paymentsFiltered.filter(p => this.selectedStatus == p.status);
			}

			if(this.receipt) {
				paymentsFiltered = paymentsFiltered.filter(p => p.receipt);
			}

			return paymentsFiltered;
		}
  },
	methods: {
		saveBankTransferInfo() {
			if (this.$refs.bankTransferInfoForm.validate()) {
        const form = new FormData();
        form.append("beneficiary", this.bankTransferInfo.beneficiary);
        form.append("iban", this.bankTransferInfo.iban);
				form.append("bic", this.bankTransferInfo.bic);
				axios
					.post("/admin/bank-transfer/edit", form)
					.then(response => {
						console.log(response.data);
						if (response.data.result == "ok") {
              this.bankTransferInfo = response.data.bank_transfer_info
							this.showBankTransferInfo = false;
						}
					})
					.catch(error => console.log(error));
			}
		}
	},
  created() {
		this.loading = true;
    axios
			.get("/admin/dashboard/payments")
			.then(response => {
				console.log(response.data);
				this.payments = response.data.payments;
				this.bankTransferInfo = response.data.bank_transfer_info;
				this.payments.forEach(p => {
					if(p.subscription_plan) {
						let index = this.subscriptionPlans.findIndex(sp => sp.id == p.subscription_plan.id);
						if(index == -1) this.subscriptionPlans.push(p.subscription_plan);
					}
					if(p.status) {
						let index = this.status.findIndex(st => st == p.status);
						if(index == -1) this.status.push(p.status);
					}
				})
				this.loading = false;
			})
			.catch(error => {
				console.log(error);
				this.loading = false;
			})
  }
}
</script>